export default "__VITE_ASSET__C683YGy1__"